import "./App.css";
import Navigator from "./routes/Navigator";

function App() {
  return <Navigator />;
}

export default App;
